import React, { useContext, useState } from 'react'
import { Content } from './style'
import { ButtonCreate, LeftSide, OptionsButton, RightSide, SectionName, SubHeaderContainer, Tab, TabsDiv } from '../../../components/subheader-style'
import pcp from '../../../assets/production-flow/pcp.svg'
import stages from '../../../assets/production-flow/stages.svg'
import production from '../../../assets/production-flow/production-flow.svg'
import { Outlet, useLocation, useNavigate, useOutletContext } from 'react-router-dom'

export interface ProductionOutletType {
  selectedStage: number
  setSelectedStage: React.Dispatch<React.SetStateAction<number>>
  tabIndex: number
  setTabIndex: React.Dispatch<React.SetStateAction<number>>
}

const tabs = [
  { path:'', image: pcp, name: 'PCP' },
  { path:'services', image: production, name: 'Ordens de Produção' },
  { path:'stages', image: stages, name: 'Etapas' }	
]

const ProductionFlowSubHeader:React.FC<{selectedStage: number, tabIndexActived: number}> = ({selectedStage, tabIndexActived}) => {
  const navigate = useNavigate()
  const location = useLocation()

  const handleButtonCreate = () => {
    if(location.pathname.includes('pcp')) navigate(`/panel/production/pcp/${selectedStage}`)
    if(location.pathname.includes('services')) navigate(`/panel/production/services/create`)
    if(location.pathname.includes('stages')) navigate(`/panel/production/stages/create`)
  }
  
  return(
    <SubHeaderContainer>
    <LeftSide>
      <SectionName>Produção</SectionName>
      <TabsDiv>
        {tabs.map((tab, index) => (
        <Tab
          key={index}
          $isFirst={index === 0}
          $isLast={index === tabs.length - 1}
          $isActive={index === tabIndexActived}
          onClick={() => {
            if(index !== tabIndexActived) navigate(tab.path)
          }}
        >
            <img src={tab.image} alt={`${tab.path}-icon`} />
            {tab.name}
          </Tab>
        ))}
      </TabsDiv>
    </LeftSide>
    <RightSide>
      <OptionsButton>f</OptionsButton>
      <OptionsButton>o</OptionsButton>
      <ButtonCreate onClick={() => handleButtonCreate()}>+ Ordem de produção</ButtonCreate>
    </RightSide>
  </SubHeaderContainer>
  )
}

const ProductionFlow = () => {  
  const [ selectedStage, setSelectedStage ] = useState<number>(1)
  const [ tabIndex, setTabIndex ] = useState<number>(0)
  
  return(
    <>
      <ProductionFlowSubHeader selectedStage={selectedStage} tabIndexActived={tabIndex} />
      <Content>
        <Outlet
          context={{
            selectedStage,
            setSelectedStage,
            tabIndex,
            setTabIndex
          }}
        />
        {/* {productionFlowSection === 'services' && <ServicesTable />}
        {productionFlowSection === 'users' && <UsersTable />}
        {productionFlowSection === 'machines' && <MachinesTable />}
        {productionFlowSection === 'reports' && <ReportsTable />} */}
      </Content>
    </>
  )
}

export default ProductionFlow